var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0029 19C1.0839 19 1.1649 18.99 1.2449 18.97L5.2449 17.97C5.4209 17.926 5.5819 17.835 5.7099 17.707L18.0029 5.41401C18.3809 5.03601 18.5889 4.53401 18.5889 4.00001C18.5889 3.46601 18.3809 2.96401 18.0029 2.58601L16.4169 1.00001C15.6609 0.244014 14.3449 0.244014 13.5889 1.00001L1.2959 13.293C1.16797 13.4211 1.07709 13.5814 1.0329 13.757L0.0329034 17.757C-0.00403403 17.9045 -0.00687104 18.0584 0.0246078 18.2071C0.0560867 18.3558 0.121053 18.4954 0.214569 18.6152C0.308085 18.7351 0.427689 18.832 0.564291 18.8987C0.700893 18.9654 0.850897 19 1.0029 19ZM15.0029 2.41401L16.5889 4.00001L15.0029 5.58601L13.4169 4.00001L15.0029 2.41401ZM2.9059 14.511L12.0029 5.41401L13.5889 7.00001L4.4909 16.097L2.3769 16.625L2.9059 14.511Z",
    fill: "#276FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOne);
export default __webpack_public_path__ + "static/media/pencil-one.3c40ca570cb3c62d9ea1a77429f8e12c.svg";
export { ForwardRef as ReactComponent };